import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface PageLoadingStateProps {
  /** Optional message below the spinner */
  message?: string;
  /** Height class for the container, defaults to full-height centering */
  className?: string;
}

/**
 * Standardised full-page loading indicator.
 * Drop this into any page's loading branch for a consistent look.
 */
export function PageLoadingState({ message, className }: PageLoadingStateProps) {
  return (
    <div role="status" aria-label={message ?? 'Loading'} className={cn('flex flex-col items-center justify-center py-24', className)}>
      <Loader2 aria-hidden="true" className="h-6 w-6 animate-spin text-muted-foreground" />
      {message && (
        <p className="mt-3 text-sm text-muted-foreground">{message}</p>
      )}
    </div>
  );
}
